export const isCypressSpecialBehaviour = () => {
  if (import.meta.server) {
    return process.env.CYPRESS_TESTING === 'true'
  }
  return !!window.cypressSpecialBehaviour
}

/* Mocks */

// mocks maps
export const __mockAutocompletepredictions = [
  {
    description: 'Montevideo, Colonia del Sacramento Departamento de Colonia',
    matched_substrings: [
      {
        length: 10,
        offset: 0,
      },
    ],
    place_id:
      'EjpNb250ZXZpZGVvLCBDb2xvbmlhIGRlbCBTYWNyYW1lbnRvIERlcGFydGFtZW50byBkZSBDb2xvbmlhIi4qLAoUChIJI9bMOHwSo5URq_Br9TkKo-USFAoSCd-qm55oEqOVEQiHzz8CuAXY',
    reference:
      'EjpNb250ZXZpZGVvLCBDb2xvbmlhIGRlbCBTYWNyYW1lbnRvIERlcGFydGFtZW50byBkZSBDb2xvbmlhIi4qLAoUChIJI9bMOHwSo5URq_Br9TkKo-USFAoSCd-qm55oEqOVEQiHzz8CuAXY',
    structured_formatting: {
      main_text: 'Montevideo',
      main_text_matched_substrings: [
        {
          length: 10,
          offset: 0,
        },
      ],
      secondary_text: 'Colonia del Sacramento Departamento de Colonia',
    },
    terms: [
      {
        offset: 0,
        value: 'Montevideo',
      },
      {
        offset: 12,
        value: 'Colonia del Sacramento',
      },
      {
        offset: 35,
        value: 'Departamento de Colonia',
      },
    ],
    types: ['geocode', 'route'],
  },
  {
    description: 'Montevideo, Paysandú Departamento de Paysandú',
    matched_substrings: [
      {
        length: 10,
        offset: 0,
      },
    ],
    place_id:
      'Ei9Nb250ZXZpZGVvLCBQYXlzYW5kw7ogRGVwYXJ0YW1lbnRvIGRlIFBheXNhbmTDuiIuKiwKFAoSCek_TQ1Yya-VEZwvAy-zeK1HEhQKEglffuRXQcmvlRFFo7NcDg5IqQ',
    reference:
      'Ei9Nb250ZXZpZGVvLCBQYXlzYW5kw7ogRGVwYXJ0YW1lbnRvIGRlIFBheXNhbmTDuiIuKiwKFAoSCek_TQ1Yya-VEZwvAy-zeK1HEhQKEglffuRXQcmvlRFFo7NcDg5IqQ',
    structured_formatting: {
      main_text: 'Montevideo',
      main_text_matched_substrings: [
        {
          length: 10,
          offset: 0,
        },
      ],
      secondary_text: 'Paysandú Departamento de Paysandú',
    },
    terms: [
      {
        offset: 0,
        value: 'Montevideo',
      },
      {
        offset: 12,
        value: 'Paysandú',
      },
      {
        offset: 21,
        value: 'Departamento de Paysandú',
      },
    ],
    types: ['geocode', 'route'],
  },
  {
    description: 'Montevideo, Barros Blancos Departamento de Canelones',
    matched_substrings: [
      {
        length: 10,
        offset: 0,
      },
    ],
    place_id:
      'EjRNb250ZXZpZGVvLCBCYXJyb3MgQmxhbmNvcyBEZXBhcnRhbWVudG8gZGUgQ2FuZWxvbmVzIi4qLAoUChIJR57blUYmoJURsF-3WRK_E8sSFAoSCXPqPfRFJqCVEQlEl_ni_45E',
    reference:
      'EjRNb250ZXZpZGVvLCBCYXJyb3MgQmxhbmNvcyBEZXBhcnRhbWVudG8gZGUgQ2FuZWxvbmVzIi4qLAoUChIJR57blUYmoJURsF-3WRK_E8sSFAoSCXPqPfRFJqCVEQlEl_ni_45E',
    structured_formatting: {
      main_text: 'Montevideo',
      main_text_matched_substrings: [
        {
          length: 10,
          offset: 0,
        },
      ],
      secondary_text: 'Barros Blancos Departamento de Canelones',
    },
    terms: [
      {
        offset: 0,
        value: 'Montevideo',
      },
      {
        offset: 12,
        value: 'Barros Blancos',
      },
      {
        offset: 27,
        value: 'Departamento de Canelones',
      },
    ],
    types: ['geocode', 'route'],
  },
  {
    description: 'Montevideo, Artigas Departamento de Artigas',
    matched_substrings: [
      {
        length: 10,
        offset: 0,
      },
    ],
    place_id:
      'EitNb250ZXZpZGVvLCBBcnRpZ2FzIERlcGFydGFtZW50byBkZSBBcnRpZ2FzIi4qLAoUChIJcdv1kvoLq5URzjbdqsb1FrcSFAoSCeMRAGOHC6uVEcmCiSdWjbmn',
    reference:
      'EitNb250ZXZpZGVvLCBBcnRpZ2FzIERlcGFydGFtZW50byBkZSBBcnRpZ2FzIi4qLAoUChIJcdv1kvoLq5URzjbdqsb1FrcSFAoSCeMRAGOHC6uVEcmCiSdWjbmn',
    structured_formatting: {
      main_text: 'Montevideo',
      main_text_matched_substrings: [
        {
          length: 10,
          offset: 0,
        },
      ],
      secondary_text: 'Artigas Departamento de Artigas',
    },
    terms: [
      {
        offset: 0,
        value: 'Montevideo',
      },
      {
        offset: 12,
        value: 'Artigas',
      },
      {
        offset: 20,
        value: 'Departamento de Artigas',
      },
    ],
    types: ['geocode', 'route'],
  },
  {
    description: 'Montevideo, Punta del Este Departamento de Maldonado',
    matched_substrings: [
      {
        length: 10,
        offset: 0,
      },
    ],
    place_id:
      'EjRNb250ZXZpZGVvLCBQdW50YSBkZWwgRXN0ZSBEZXBhcnRhbWVudG8gZGUgTWFsZG9uYWRvIi4qLAoUChIJZ5HGTU0FdZURLVhfFqeIGToSFAoSCb0LxMieBXWVEZPP08KDAd2b',
    reference:
      'EjRNb250ZXZpZGVvLCBQdW50YSBkZWwgRXN0ZSBEZXBhcnRhbWVudG8gZGUgTWFsZG9uYWRvIi4qLAoUChIJZ5HGTU0FdZURLVhfFqeIGToSFAoSCb0LxMieBXWVEZPP08KDAd2b',
    structured_formatting: {
      main_text: 'Montevideo',
      main_text_matched_substrings: [
        {
          length: 10,
          offset: 0,
        },
      ],
      secondary_text: 'Punta del Este Departamento de Maldonado',
    },
    terms: [
      {
        offset: 0,
        value: 'Montevideo',
      },
      {
        offset: 12,
        value: 'Punta del Este',
      },
      {
        offset: 27,
        value: 'Departamento de Maldonado',
      },
    ],
    types: ['geocode', 'route'],
  },
]

export const __mockGeocoderResultPlaceDetails = {
  address_components: [
    {
      long_name: 'Montevideo',
      short_name: 'Montevideo',
      types: ['route'],
    },
    {
      long_name: 'Colonia del Sacramento',
      short_name: 'Col. del Sacramento',
      types: ['locality', 'political'],
    },
    {
      long_name: 'Departamento de Colonia',
      short_name: 'Departamento de Colonia',
      types: ['administrative_area_level_1', 'political'],
    },
    {
      long_name: 'Uruguay',
      short_name: 'UY',
      types: ['country', 'political'],
    },
    {
      long_name: '70000',
      short_name: '70000',
      types: ['postal_code'],
    },
  ],
  formatted_address: 'Montevideo, 70000 Col. del Sacramento, Departamento de Colonia, Uruguay',
  geometry: {
    bounds: {
      northeast: {
        lat: -34.45918659999997,
        lng: -57.8317068,
      },
      southwest: {
        lat: -34.46214380000004,
        lng: -57.8323677,
      },
    },
    location: {
      lat: () => -34.4603486,
      lng: () => -57.8321276,
    },
    location_type: 'GEOMETRIC_CENTER',
    viewport: {
      northeast: {
        lat: -34.45918659999997,
        lng: -57.8306882697085,
      },
      southwest: {
        lat: -34.46214380000004,
        lng: -57.8333862302915,
      },
    },
  },
  place_id:
    'EjpNb250ZXZpZGVvLCBDb2xvbmlhIGRlbCBTYWNyYW1lbnRvIERlcGFydGFtZW50byBkZSBDb2xvbmlhIi4qLAoUChIJI9bMOHwSo5URq_Br9TkKo-USFAoSCd-qm55oEqOVEQiHzz8CuAXY',
  types: ['route'],
}

export const MOCK_GOOGLE_MAPS = {
  AUTOCOMPLETE_PREDICTIONS: __mockAutocompletepredictions,
  SESSION_TOKEN: 'cypress-session-token',
  GEOCODER_RESULT_PLACE_DETAILS: __mockGeocoderResultPlaceDetails,
} as const

export const GET_GOOGLE_MOCK_DATA = (
  item: 'AUTOCOMPLETE_PREDICTIONS' | 'SESSION_TOKEN' | 'GEOCODER_RESULT_PLACE_DETAILS'
) => {
  if (import.meta.server) return MOCK_GOOGLE_MAPS[item]
  const storageItem = localStorage.getItem(item)
  return storageItem ? JSON.parse(storageItem) : MOCK_GOOGLE_MAPS[item]
}
